import createIcon from '../../createIcon';

/**
 * @component @name School
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxMy4xOFYxNy4xOEwxMiAyMUwxOSAxNy4xOFYxMy4xOEwxMiAxN0w1IDEzLjE4Wk0xMiAzTDEgOUwxMiAxNUwyMSAxMC4wOVYxN0gyM1Y5TDEyIDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const School = createIcon('School', [
  [
    'path',
    {
      d: 'M5 13.18V17.18L12 21L19 17.18V13.18L12 17L5 13.18ZM12 3L1 9L12 15L21 10.09V17H23V9L12 3Z',
      key: '1sn590',
    },
  ],
]);

export default School;
